import { hasOwnProperty } from "../../infra3d";
import { FeatureStyle } from "../featuretree/internal";
import { Obj } from "../internal";
/**
 * @class LayerEditor
 */
export class LayerEditor extends Obj {
    constructor(scene, layer, opt_options) {
        super();
        this._layer = null;
        this.featuresinsert = null;
        this.featuresupdate = {};
        this.featuresdelete = [];
        this.scene = scene;
        this._layer = layer;
        //Init FeatureCollection
        const featurehandler = this.scene.getFeatureHandler();
        const highlightlayerstyle = new FeatureStyle({
            stylename: "editcontroller_highlightlayerstyle",
            rules: [
                {
                    filter: "",
                    symbolizer: "point",
                    params: {
                        "font-marker": {
                            name: "cross",
                        },
                        size: 8,
                        stroke: [1, 1, 0, 1.0],
                    },
                },
                {
                    filter: "",
                    symbolizer: "line",
                    params: {
                        "stroke-width": 3,
                        stroke: [1, 1, 0, 1.0],
                    },
                },
                {
                    filter: "",
                    symbolizer: "polygon",
                    params: {
                        fill: [1, 1, 0, 0.4],
                    },
                },
            ],
        });
        this.featuresinsert = featurehandler.createFeatureCollection(this.scene.getToolHandler().defaultstyles.draw, highlightlayerstyle, this._layer.layername + "_drawfc", true, this._layer.isframefeaturelayer);
    }
    insertFeatures(geojson) {
        if (geojson.type == "FeatureCollection") {
            for (let j = 0; j < geojson.features.length; j++) {
                const raw_feature = geojson.features[j];
                this.propagateDefaultValues(raw_feature.properties);
                this.featuresinsert.addFeatureFromGeoJSON(raw_feature);
            }
            this.featuresinsert.update();
            return this.featuresinsert;
        }
        else if (geojson.type == "Feature") {
            this.propagateDefaultValues(geojson.properties);
            return this.featuresinsert.addFeatureFromGeoJSON(geojson);
        }
    }
    updateFeatures(geojson) {
        let features = [];
        if (geojson.type == "FeatureCollection") {
            features = geojson.features;
        }
        else if (geojson.type == "Feature") {
            features = [geojson];
        }
        for (let i = 0; i < features.length; i++) {
            this.featuresupdate[features[i].id.toString()] = features[i];
            this.propagateDefaultValues(features[i].properties);
        }
    }
    deleteFeatures(ids) {
        for (let i = 0; i < ids.length; i++) {
            if (this.featuresdelete.indexOf(ids[i]) < 0) {
                delete this.featuresupdate[ids[i].toString()];
                this.featuresdelete.push(ids[i]);
            }
        }
    }
    propagateDefaultValues(properties) {
        //propagate defaultvalues
        for (let i = 0; i < this._layer.propertydef.length; i++) {
            const pdef = this._layer.propertydef[i];
            if (pdef.propagation) {
                if (hasOwnProperty(properties, pdef.key)) {
                    pdef.defaultvalue = properties[pdef.key];
                }
            }
        }
    }
    reset() {
        this.featuresinsert.destroy();
        this.featuresinsert.update();
        this.featuresupdate = {};
        this.featuresdelete = [];
    }
}
//# sourceMappingURL=layereditor.js.map